import api from './api';

export default {

  /**
   * 数组相加
   * @param oa oldArry
   * @param na newArry
   */
  arryAdd: function (oa, na) {
    if (na) {
      na.forEach(function (v) {
        oa.push(v)
      });
    }
  },
//判断是否为数字
  isNumber(str) {
    return !isNaN(str);
  },

  isInteger(str) {
    return this.isNumber(str) && str % 1 === 0;
  },

  //判断是否为Url
  isUrl(url) {
    url = typeof url !== 'string' ? url + '' : url;
    return url.startsWith("http");
  },

  /**
   * 是否数字，字母，符号
   * @param str
   * @returns {boolean}
   */
  isNumberLetterSymbol(str) {
    return /^[a-zA-Z0-9!@#$%^&*()_+|{}?><\-\]\\[\/]*$/g.test(str);
  },

  /**
   * 是否汉字、数字、字母
   * @param str
   * @returns {boolean}
   */
  isChineseNumberLetter(str) {
    return !/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g.test(str);
  },

  /**
   * 合并两个数组并去重
   * @param arr1
   * @param arr2
   * @param type add 相同时只留下一个，remove 相同时删除
   * @returns {*}
   */
  mergeArray(arr1, arr2, type = 'add') {
    switch (type) {
      case 'add':
        for (let i = 0; i < arr1.length; i++) {
          for (let j = 0; j < arr2.length; j++) {
            if (arr1[i] === arr2[j]) {
              arr1.splice(i, 1);
            }
          }
        }
        for (let i = 0; i < arr2.length; i++) {
          arr1.push(arr2[i]);
        }
        return arr1;
        break;
      case 'remove':
        const tempArray1 = [];
        const tempArray2 = [];

        for (let i = 0; i < arr2.length; i++) {
          tempArray1[arr2[i]] = true;
        }

        for (let i = 0; i < arr1.length; i++) {
          if (!tempArray1[arr1[i]]) {
            tempArray2.push(arr1[i]);
          }
        }
        return tempArray2;
        break;
    }
  },

  /**
   * 数组去重
   * @param arr
   * @returns {Array}
   */
  uniqArray(arr) {
    return Array.from(new Set(arr));
  },

  yestardayTimeDate() {
    let day = new Date();
    return day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
  },

  /**
   * 是否为手机号码
   * @param phone
   * @returns {boolean}
   */
  isPhone(phone) {
    let exp = /^1[3-9][0-9]\d{8}$/;
    return exp.test(phone)
  },


  get3MonthBefor() {
    let resultDate, year, month, date, hms;
    let currDate = new Date();
    year = currDate.getFullYear();
    month = currDate.getMonth() + 1;
    date = currDate.getDate();
    hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0' + currDate.getSeconds() : currDate.getSeconds());
    switch (month) {
      case 1:
      case 2:
      case 3:
        month += 9;
        year--;
        break;
      default:
        month -= 3;
        break;
    }
    month = (month < 10) ? ('0' + month) : month;
    resultDate = year + '-' + month + '-' + date + ' ' + hms;
    return resultDate;
  },

  formatDate(time) {
    let date = new Date(time),
      year = date.getFullYear(),
      month = date.getMonth() + 1,
      day = date.getDate(),
      hour = date.getHours(),
      min = date.getMinutes(),
      sec = date.getSeconds();
    return year + '-' + month + '-' + day + ' ' + hour + ':' + min + ':' + sec;
  },

  getQuery(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'),
      r = parent.window.location.search.substr(1).match(reg);

    if (r != null) {
      return decodeURIComponent(r[2]);
    }
    return null;
  },

  /*
  required 不得为空
  maxlen 最大长度，需要传入对象，对象中需有len和text字段
  minlen 最小长度，需要传入对象，对象中需有len和text字段
  phone 手机格式
  int   整数
  float 小数
  chinese 中文
  english 英文
  idcard 身份证
  symbol 符号
   */
  checkData(type, val, data) {
    switch (type) {
      case 'required':
        if (!val) return false
        break;
      case 'minlen':
        if (val.length < data) return false
        break;
      case 'maxlen':
        if (val.length > data) return false
        break;
      case 'phone':
        if (!/^[1][3-9][0-9]{9}$/.test(val)) return false
        break;
      case 'int':
        if (!/^[0-9]*$/.test(val)) return false
        break;
      case 'float':
        if (!/^(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*))$/.test(val)) return false
        break;
      case 'chinese':
        if (/[^\u4e00-\u9fa5]/.test(val)) return false
        break;
      case 'english':
        if (!/^[A-Za-z]+$/.test(val)) return false
        break;
      case 'idcard':
        // if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val)) return false
        if (!/^[1-9]\d{7}((0\d)|bai(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(val)) return false
        break;
      case 'symbol':
        if (/[`~!@#$%^&*()_+<>?:'{},./;'[\]]/im.test(val) || /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im.test(val)) return false
        break;
      case 'numberEnglish':
        if (!/^[A-Za-z0-9]+$/.test(val)) return false
        break;
      case 'idExp':
        if (!/^([0-9]{4})([0-9]{2})([0-9]{2})$/.test(val)) return false
        break;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/utility/utils.js